import ImageHero from "pages/Dashboard/assets/hero-dashboard.png?v2";
import { ReactComponent as IconUser } from "assets/images/icons/user.svg";
import ContentContainer from "layout/Content/ContentContainer";
import FavoritesPanel from "pages/Dashboard/FavoritesPanel";
import BulletinPanel from "pages/Dashboard/BulletinPanel";
import LastRepliesPanel from "pages/Dashboard/LastRepliesPanel";
import LatestGroupsPanel from "pages/Dashboard/LatestGroupsPanel";
import MessageBoxPanel from "pages/Dashboard/MessageBoxPanel";
import TipOfTheDay from "pages/Dashboard/TipOfTheDay";
import TopBanner from "layout/TopBanner/TopBanner";
import Button from "components/ui/Button/Button";
import { useAccount } from "context/AccountContext";
import { useDialog } from "context/DialogContext";
import "pages/Dashboard/Dashboard.scss";
import ProfileCreateUpdate from "pages/Profile/ProfileCreateUpdate";
import useEntity from "hooks/useEntity";
import BulletinCreateButton from "features/bulletins/components/BulletinCreateButton";

function Dashboard() {
  const { entity, isLoading } = useEntity('/startpagina', 'page');

  const { showDialog } = useDialog();
  const { profile } = useAccount();

  const title = `Welkom op uw startpagina ${ profile?.title?.value }`;
  const intro = entity?.field_intro?.value;

  return (
    <>
      <TopBanner title={ title }
                 intro={ intro }
                 image={ ImageHero }
                 hideBottomActions={ true }
                 hasRoundedCorners={ true }>

        { !isLoading && <BulletinCreateButton categoryId={ entity.field_bulletin_category?.id }/> }

        <Button variant="secondary" onClick={ () => showDialog(<ProfileCreateUpdate/>) }>
          <IconUser/>
          Profiel aanpassen
        </Button>
      </TopBanner>

      <ContentContainer containerPadding={ true }>
        <TipOfTheDay/>

        <div className={'dashboard-panels'}>
          <MessageBoxPanel/>
          <LastRepliesPanel/>
          <FavoritesPanel/>
        </div>

        <div>
          <LatestGroupsPanel/>
        </div>

        <div>
          <BulletinPanel/>
        </div>
      </ContentContainer>
    </>
  );
}

export default Dashboard;
